import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable()
export class ScormProvider {

    constructor(private http: HttpClient) {}

    launch(id: number, params: any): Observable<any> {
        return this.http.post(`${environment.envVar.API_URL}/learning/scorms/${id}/url`, params);
    }
}
